import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType, ENG_DAYS } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'ScheduleZones';

export type ScheduleZonesProps = {
  zone_name?: string;
  zone_start_time?: number;
  day_selection?: ENG_DAYS;
};

export class ScheduleZones extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  zone_name?: string;
  zone_start_time?: number;
  day_selection?: ENG_DAYS;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      zone_name: { type: 'String', editable: true, label: 'zone_name', name: 'zone_name', description: 'The id of the irrigation zone ' },
      zone_start_time: {
        type: 'object',
        editable: true,
        label: 'zone_start_time',
        name: 'zone_start_time',
        description: 'The start time (local) for the zone to start irrigating',
      },
      zone_duration: { type: 'Number', editable: true, label: 'zone_duration', name: 'zone_duration', description: 'The time set for the programme' },
      day_selection: {
        type: 'Enum',
        editable: true,
        label: 'day_selection',
        name: 'day_selection',
        description: 'The selected days to run the programme on (local time)',
        enumKv: ENG_DAYS,
      },
    };
  };
}
